import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ReportService {
    static serviceName: string;
    constructor(private http: HttpClient,) {
        ReportService.serviceName = `${environment.apiUrl}/report`;
    }

    openInvoiceReport(filter) {
        const reportName = 'invoiceReport';
        const qsInvoiceId = `&invoiceId=${filter}`;
        const url = `${ReportService.serviceName}/${reportName}?${qsInvoiceId}`;
        window.open(url, '_blank');
    }

    async getNum() {
        const reportName = 'InvoiceReport';
        const result = await this.http.post(`${ReportService.serviceName}/invoiceReport`, {invoiceId: 8}).toPromise();
        return result;
    }
}
